module.exports = __webpack_public_path__ + "img/kudos.ba0359c1.svg";